import request from '@/utils/request'

// 获取用户消息
export function getMessages(params) {
  return request({
    url: `/messages`,
    method: 'get',
    params
  })
}
// 删除消息
export function deleteMessage(data) {
  return request({
    url: `/messages`,
    method: 'delete',
    data
  })
}
// 获取模板消息
export function getMessage(id) {
  return request({
    url: `/messages/${id}`,
    method: 'get'
  })
}
// 更新消息状态
export function patchMessage(id, data) {
  return request({
    url: `/messages/${id}`,
    method: 'patch',
    data
  })
}
// 获取预警输出
export function getCurrentWarning(id) {
  return request({
    url: `/warnings/${id}/output`,
    method: 'get'
  })
}
// 获取消息输出
export function getMessageOutPut(id) {
  return request({
    url: `/messages/${id}/output`,
    method: 'get'
  })
}
// 预警导出
export function exportWarning(id) {
  return request({
    url: `/warnings/${id}/export`,
    method: 'get',
    responseType: 'blob'
  })
}
